module.exports = "observe-eye"